<template>
  <div>
    <p>{{ trans('series.select_grouping_explanation') }}</p>
    <p>
      {{ trans('series.select_one_of_options') }}:
      <span
        class="fa fa-question-circle-o"
        data-toggle="tooltip"
        :title="trans('series.contact_feedback')"
      />
    </p>

    <!--cluster type-->
    <div style="margin-left: 20px;">
      <form-group>
        <input
          id="cluster_per_week"
          v-model="type"
          type="radio"
          value="cluster_per_week"
        >
        <label for="cluster_per_week">
          {{ trans('series.grouping_option.min_number_start') }}
          <input
            id="per_week"
            v-model="perWeek"
            type="number"
            :disabled="type !== 'cluster_per_week'"
            class="form-group"
            style="width: 50px;"
            min="1"
          >
          {{ trans('series.grouping_option.min_number_end') }}
        </label>
      </form-group>

      <form-group>
        <input
          id="cluster_per_name"
          v-model="type"
          type="radio"
          value="cluster_per_name"
        >
        <label for="cluster_per_name">
          {{ trans('series.grouping_option.all_names') }}
        </label>
      </form-group>

      <form-group>
        <input
          id="cluster_per_lesson"
          v-model="type"
          type="radio"
          value="cluster_per_lesson"
        >
        <label for="cluster_per_lesson">
          {{ trans('series.grouping_option.all_lessons') }}
        </label>
      </form-group>
    </div>

    <div
      v-if="type === 'cluster_per_lesson'"
      id="message_combine_lessons"
      class="alert alert-default"
      style="margin: 5px 0 0 0; max-width: 500px; color: black;"
    >
      {{ trans('series.lessons_combined') }}
    </div>
    <!--select shopping-->
    <div
      id="select_shopping"
      style="margin-top:20px;"
    >
      <p>{{ trans('series.shopping_allowed_explanation') }}</p>

      <form-group style="margin-left: 20px !important;">
        <input
          id="allow_shopping"
          v-model="allowShopping"
          type="checkbox"
        >
        <label for="allow_shopping">
          {{ trans('series.shopping_allowed') }}
        </label>
      </form-group>
    </div>

    <!--number of components-->
    <div
      v-if="type !== null"
      id="cluster_achieve"
    >
      <hr>
      <p>{{ trans('series.goal_explanation') }}</p>
      <div class="col-xs-12">
        <selector-component
          id="serie_goal_type'"
          v-model="serieGoalType"
          :label="trans('series.serie_goal_types')"
          :options="serieGoalTypes"
          :value="serieGoalType"
          :label-width="3"
        />
      </div>

      <div
        v-if="['percentage', 'absolute', 'missing'].includes(serieGoalType)"
        class="col-sm-12 form-group"
        :class="{ 'has-error':goalNumberError }"
      >
        <div class="col-sm-3">
          <label
            class="control-label"
            for="serie_goal"
          >{{ trans('series.number_to_achieve') }}</label>
        </div>
        <div class="col-sm-3">
          <input
            id="serie_goal"
            v-model="serieGoalNumber"
            class="form-control"
            type="number"
            min="1"
          >
          <p
            v-if="goalNumberError != null"
            class="help-block"
          >
            {{ goalNumberError }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormGroup from './../../lecturer-flow/components/FormGroup.vue'
import SelectorComponent from '../FormComponents/SelectorComponent.vue'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'CreateGoal',
  components: { FormGroup, SelectorComponent },

  data () {
    return {
      serieGoalTypes: {
        all: Lang.get('series.all_components'),
        percentage: Lang.get('series.percentage_to_achieve'),
        absolute: Lang.get('series.num_to_achieve'),
        missing: Lang.get('series.missing_components'),
      },
      goalNumberError: null,
    }
  },

  computed: {
    type: {
      get () {
        return this.$store.state.eventSeries.serie_rules.type
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'type', value: newValue })
      },
    },
    perWeek: {
      get () {
        return this.$store.state.eventSeries.serie_rules.per_week
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'per_week', value: newValue })
      },
    },
    allowShopping: {
      get () {
        return this.$store.state.eventSeries.serie_rules.allow_shopping
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'allow_shopping', value: newValue })
      },
    },
    serieGoalType: {
      get () {
        return this.$store.state.eventSeries.serie_rules.serie_goal_type
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'serie_goal_type', value: newValue })
      },
    },
    serieGoalNumber: {
      get () {
        return this.$store.state.eventSeries.serie_rules.serie_goal_number
      },
      set (newValue) {
        newValue = newValue === '' ? null : newValue
        return this.$store.dispatch('update_serie_rules', { rule: 'serie_goal_number', value: newValue })
      },
    },
  },

  watch: {
    type: function (newValue) {
      this.goalNumberError = null
      if (newValue == null) {
        return this.$emit('canNotFinishStep')
      }
      this.updateEventSeries()
      if (this.serieGoalType === 'absolute') {
        if (this.biggerThanNumberOfGoalComponents(this.serieGoalNumber)) {
          this.goalNumberError = Lang.get('series.not_possible_number')
        }
      }
      if (this.serieGoalType !== 'all' && this.serieGoalNumber == null) {
        return this.$emit('canNotFinishStep')
      }
      return this.$emit('canFinishStep')
    },

    serieGoalType: function (newValue) {
      this.goalNumberError = null
      if (this.type === null || (newValue !== 'all' && this.serieGoalNumber == null)) {
        return this.$emit('canNotFinishStep')
      }
      if (newValue === 'absolute' && this.biggerThanNumberOfGoalComponents(this.serieGoalNumber)) {
        this.goalNumberError = Lang.get('series.not_possible_number')
      }
      return this.$emit('canFinishStep')
    },

    serieGoalNumber: function (newValue) {
      this.goalNumberError = null
      if (this.serieGoalType === 'all') {
        return
      }
      if (newValue == null || newValue === '' || newValue === 0) {
        return this.$emit('canNotFinishStep')
      }
      if (this.serieGoalType === 'absolute') {
        if (this.biggerThanNumberOfGoalComponents(this.serieGoalNumber)) {
          this.goalNumberError = Lang.get('series.not_possible_number')
        }
      }
      return this.$emit('canFinishStep')
    },
    allowShopping: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateEventSeries()
      }
    },
    perWeek: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        let ids = this.biggerThanNumberOfEvents(newValue)
        this.$store.dispatch('add_coloured_clusters', { event_cluster_ids: ids })
      }
    },
  },

  created () {
    if (this.type != null) {
      this.updateEventSeries()
    }
  },

  methods: {
    biggerThanNumberOfGoalComponents (value) {
      let series = this.$store.state.eventSeries.event_series
      let returnValue = false
      Object.keys(series).some(serieId => {
        let numberOfClusters = Object.keys(series[serieId].relationships.eventClusters.data).length
        if (value > numberOfClusters) {
          returnValue = true
          return true
        }
      })
      return returnValue
    },

    biggerThanNumberOfEvents (value) {
      let series = this.$store.state.eventSeries.event_series
      let returnValue = []
      Object.keys(series).forEach(serieId => {
        let clustersOfSerie = Object.values(series[serieId].relationships.eventClusters.data)
        clustersOfSerie.forEach(cluster => {
          let clusters = this.$store.state.eventSeries.event_clusters
          let numberOfEvents = Object.keys(clusters[cluster.id].relationships.events.data).length
          if (value > numberOfEvents) {
            returnValue.push(cluster.id)
          }
        })
      })
      return returnValue
    },

    updateEventSeries () {
      return axios.post('/admin/attendance-goals/serie-preview', {
        course_information: this.$store.state.eventSeries.courses,
        serie_rules: this.$store.state.eventSeries.serie_rules,
      }).then((data) => {
        this.$store.dispatch('update_event_series', { data: data.data })
        this.$emit('canFinishStep')
      }).catch(error => defaultErrorMessage(error))
    },
  },
}
</script>

<style>

</style>
